import { render, staticRenderFns } from "./MaintenanceSummaryBoard.vue?vue&type=template&id=b2edd7fe&scoped=true"
import script from "./MaintenanceSummaryBoard.vue?vue&type=script&lang=js"
export * from "./MaintenanceSummaryBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2edd7fe",
  null
  
)

export default component.exports